module.exports = __webpack_public_path__ + "assets/others.495a3afd.svg";